import { render, staticRenderFns } from "./AppMenuBtn.vue?vue&type=template&id=05c3b916&scoped=true"
import script from "./AppMenuBtn.vue?vue&type=script&lang=ts"
export * from "./AppMenuBtn.vue?vue&type=script&lang=ts"
import style0 from "./AppMenuBtn.vue?vue&type=style&index=0&id=05c3b916&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c3b916",
  null
  
)

export default component.exports